import { Button, Grid, TextField } from '@mui/material';
import * as React from 'react';
import { useHistory } from "react-router-dom";
import { BasePageStyles } from '../../hooks/styles';
import { IMAGES_URL } from '../../constants/Images';
import Api from '../../redux/lib/api';
import { LOGIN } from '../../redux/constants/api.url';
import { default as ProductThumb } from '../../components/productThumb';
import { PRODUCTS } from '../../constants/Products';
import config from '../../config';


interface AboutProps {}

export const AboutComponent: React.FC<AboutProps> = (props) => {
	const classes = BasePageStyles();
	const history = useHistory(); 

	<img src={IMAGES_URL.NARCAN_LANDING} style={{maxWidth: '100%'}}/>

	const routeChange = (path: string) =>{ 
	 	history.push(path);
	 }

	const products = PRODUCTS;

	return (
		<div style={{width: '100%'}}>
			
				
			<div style={{
				 backgroundImage: 'url(https://www.narcanworkplace.com/wp-content/uploads/2024/01/hero-banner-about.jpg)',
				 backgroundPosition: 'top right',
				 backgroundRepeat: 'no-repeat',
				  backgroundSize: 'auto',
				  width: '100%',
				  minHeight: 512,
				  

			}} >
				<div style={{
					paddingTop: 200,
					textAlign: 'left',
					marginLeft: 222,
					marginRight: 222,
					height: 512
				}} >
					<h1 style={{
						fontSize: 60,
					color: '#000',
					fontWeight: 600
					}}>
						About Us
					</h1>
					<h2 style={{
						fontSize: 20,
						fontWeight: 600,

					}}>
						Committed to ensuring that safety and preparedness are <br/>within reach for every employee.
					</h2>
				</div>
			</div>{/*end header image div */}

					<div style={{
					textAlign: 'left',
					marginLeft: 222,
					marginRight: 222,
							fontSize: 16,
							
							color: '#2D2D2D',
							fontWeight: 400

					
				}} >
						<h3 style={{
						fontWeight: 600,
    				fontSize: 36
					}}
					>
					About Emergent BioSolutions</h3>

						<p 
						>
						At Emergent, our mission is to protect and enhance life. For 25 years, we’ve been at work defending people from things we hope will never happen—so we are prepared just in case they ever do. We provide solutions for complex and urgent public health threats through a portfolio of vaccines and therapeutics that we develop and manufacture for governments and consumers. We also offer a range of integrated contract development and manufacturing services for pharmaceutical and biotechnology customers. To learn more about how we plan to protect or enhance 1 billion lives by 2030, visit our&nbsp;<a 
						style={{
							color: '#c36',
							textDecoration: 'none'
						}} 
						href="https://www.globenewswire.com/Tracker?data=0owcmN-wyp4JVH-i70jpHNt51YxJ7HjBaPxjB1SJxfqQrBgnjryt0qKklRhllXn8KVNHrotwdlaExtssN4QzHU7opuXeWwYYVzB3dmIl--aJVAmMRq4ZWfHF6dWqs985yGH90RCWhScWy-yBLeaAhdSNjrWfTmIMZ6OPHX1U3TybJmViKzhAbETLyl56zwWcDarIINnOsu8_5lfT13qsxmMAaLel7AVDrvDNQ3vN7rQYL_YbgOgRvZCAIYa8rv_gkkNSu2ZkO52Y_uCvBoPnsJ1DXlQ7ph4_qT1Zz7Q2va3wfBXdDMuFcLkewk5Txe5sUHUeu-4vhAmE7tD5NNcHyDYUUNShou9oQLQrtkljEeISudll1_nL-0P0YmMo_-ImdhOuVr4eGAQhXBM-v6b1q1BSuz_6qrXSxfuvVAUayUHZaoRZXHltNYVzSyyE8JfC" target="_blank" rel="noopener">website</a>&nbsp;and follow us on&nbsp;<a style={{
							color: '#c36',
							textDecoration: 'none'
						}}  href="https://www.globenewswire.com/Tracker?data=s80lIM57FhCDzu6KFN3Q7C5VIu_g3oHCf3TV85VK9vzQGEgp0x8bcQx0wF-8x3MYyhMrYBIOgdUTQmzvwFgha0_LwKqhHsj3jS206cUDhVXkXR-XO6y8ix62bS8TzQ-RiG-C96lHDvvXK9SufBcZw19RLHqq7yxPpwUwpW6PUDk_Isfyim_0Qjl36reVYnE_rB0a8bECnzpZvaX-kGGl4b9mfYqA6RI5DC138ERroVj9od647u_mbwZ0U04RL0GH9KTaZQHJuMdtb6bCFka_0WONmltdQKqLsAO-b5-uGLGlIcenmVKIUVU0TEAxFae5tPjswcO3LhgNgGyff6lx-rdQexXupSGzIh7fglvkQAC3f0u7sdaJVoVT_97qhn47O9ZqZxwc4A3D9pdNA9ybtYDi5X6H8qAr61c3E6LJvpLSWJkgtvXUtDdnpkMjFhrkqsLoK2p7vNDp_-FYn3g9-cFNNXnspOJeOhnLkF0jyeDnMO60mPtIKHsHLHbMhb6rBG3RL2Kr48CvEGkpeLnBXCf0LRjEmP2sB9krl1TmS87iu0IjTqUDrANq_AQjTBr9G1mzGiq34UpZ0KskDxcLmIM1bdPpqO9ux1YNpzOdV6kvg3HkIwWtFMQLfFBTzzxSKTvBf8HH0cN0heppgq46cRaoDw_r9fUC43um7MRbMCRE-OjsgnoYHgMpA3hRsrwYTA7z0ijrJdqeIBlBojz-agC45gdpqSaOG66jBXQoRlia7_2NOyiracsT4RHgjEWbp19fpf779h0Cwnqs4D1cBsULNP6RACH_r7VgLTBOEiLbh_WK_qL-HrflldVYZ00k-HBEj9_NZr_0cFAjVVfPArAaURhJ4tmKVOgdcnOQZAAxooxiu00tsgmWTWzvSHN13fxa_2uIvdJdKnWMzPGgpd_VFP7T1mBQr8ZUFCfUS1yhi2ASwDgrH-DlDqTDUTjN3pqUsx7WOjhfzGKIlVC1OMQSVH6DPgG7aNjf5gT0qCHoE4J7V5iUS-ntC34SUm9hyTEcGyfD8AI6__VWIrXrrjivk9toAmO3llW4XhPPts3V8kWa-_ZC2ki4eumjtJY8vDyn76Kn7LNmuoq7XMiDYkXjHjZciSXDrXTYswz8b8ZbuixNhoZZRpAdJG73BnXbewS3wdcDJOK8AYfjDwFfv8KmPI_bboTnXCdryPuj3MtYQu1UAHgxm-UZfC8eWmR5iz_JhdZaDgYY39hCfS_VMFTE-kUnObuYSwHLXK2SXGhgS7Iv1Z7zLqoxJe2H4CjUUAUw96DsujXiGkOZa68kU5JY4L8OHz1VwAC-3HbEbhzlcndTyre4iN3oIDUD479kh_PJ6KNLHfHYCRpLUWwCnfouiKOpJTthRurxA9flzeCEQbrBbnfgrqxVmBaBwDHasYMmD1l5uVnOEU0YQT2R923oRbzV-I7ZLUef03E-VI3ipuJKdRkfNSbE1vnvC7WmiPbItkqLQ-6eNuBWYlyZYvPevFK_hrxeJu1z73xDcmNUlnOZWXTlcfT9ATTO4YZxyQLBs6Iny3BoeEGSn0U1Z8GmPfGdjA7eKu9ITGUEcy6GjaAQBCX-AnN1xT2rW1Wk81uBQW68ohkafFBw0CNFIg==" target="_blank" rel="noopener">LinkedIn</a>,&nbsp;<a style={{
							color: '#c36',
							textDecoration: 'none'
						}} href="https://www.globenewswire.com/Tracker?data=--KNOHqjoJPGW_kK47TM49ubX0MYhs56A6YJqtOlO4x8khNdfozGiwt6sHXdngPeS3R2Mj59iiLBzfp-UDwWS_U4GmlsJhOme0lG283UlOKi_aoGZSE4hHld0FhagSbwMQxMwiH7P1jYtfzogkasGDK10_u1iogzMq0r7oyynbNw5ehq83V_Dc9QncQX2xlBQVHuY9KNg37DB4dz-sRm-DUMqhgaFVWidDkxBVfBNZIGIYxyh19FyZHSJOFoYISQYeAZhDkmet_bTxwHpTfItNJWBVwuk60Wsf9_y5Nx0_h5lOoJvZtOJlLr10tcHGpyds64FMcTGUF7lo7aPM6Andn8ZTo0hVrIve-f-GvmmHlIKGry4b6KOvUIxDI8Kyurabawvx5zEizgZOzXPu7nGO1Bz-TIAbMMaBCBYkK8mwa5NP3y90hULlnEqYbKEYqU945LhZB9Aj3X9WR7dxfJZ2mXX3voNNHHkiJj9EE5qKYamNW3uQ5fcc3wKXbCYFpvJf2QjbGtzWpJrGDu6ajz72Yi0swjbWxoYXEoRDf_BWxACCMybY_OEtnAAnOJixMQI9zEkybcQ7TpXyZH-sqcjBAKheSpcfuvhybuPIS_pvNFpLORzJ9vClI87dUTnzC8m4W_Yqv9dO9NmK3xvcNkJUVMakVIIPLTZsP2NwKr4SD5z-E6YbwqWiugxRFko_hAMnuA0K_bAWgKNoFQG_408SmhHV008_oxZNe_-u9CgiMgjDknGCv7CyOS1Hfhll9nb7Q21tkS-fcxgMDzmKvQD_FXkhfpSyAerP1TbENlSBpVyjxJysJ1ZdSK-uJ0ylguBNuQPR2KpjzT4SSgL4YaedYbvFsfZXnMDHyNdUXDyB5gF-AuMvRZ_f7VZ_lGgaldEoo9ljc76JVWkkdqFo-2nkG-zAQxMC-gJ2Bhur6d3tEuAEPDegQn7U7AJj8tmcj2JkhsgMIEigh8uZYLX-OSVk1_FS0wPnXJOdzqy9DqZ29_LVCi7_u0HE8dkfp2jhpOoI2DMbhZxg_TxtPcTC99MJUDYwCW1dP-w3wrbmuiDHPxqmFBHRcf6FC0pnCUDXmCU9IP-7RmplbpRIV62UiMRRFkLVuh8nr2aHYIy08hTWvOByusv9mwGt5PtoodoyA13LPZkeiWZwzOS1ChlgYPnGS7-c7fJHGllre7_4gOOvzUYoeigwHoXMO-0d81kJm6JcvI0WxdXXvgAwlYEXLwjbp7yOnE-lTCqx6XfVvD0JRIChUR34zrLhAPCbdwS-FDgLDMuDrJGCoYxSPGGFTDc5UtNBdchE6wKlwL64tvrfjaHFwjQpZD4UHb7dmkHQEqcIsFbRFEj2Gk1hQrIfrSPIp-HrnCZYvrp7JKfLmFd8KrfjY9UjAWEFL2rA9wm0riM_X39Q8oYJv9YgZzj52lk7ieaXRwTctcPFfuqQ6StI7ezESjDY-ujrss_zCnkHZjtjDs7W1LCT3wawjphrQXpRlIaJDm14MJVliU_LE0frHyBf6UiTWXSyyn1BTETYVS" target="_blank" rel="noopener">X</a>,&nbsp;<a style={{
							color: '#c36',
							textDecoration: 'none'
						}}  href="https://www.globenewswire.com/Tracker?data=Mpx1v7-n2TNbCNxjtX5_XY5UllF_LbTla-D0R1gJm--64BxTkTkuqPHSZMbQqaHkjuUL03QkYWOUnsdZ4FrlFCNBrYkptNmBE_5WRaXbN9S4EIZZAfClbhg7zQKdaBjRYep9srwRR9D7nWrfGGzBEIurHMyHT-LVuT4VQjDOgB3kBIlLKqwOqMtuvtBp9OWKWehaJZCUWXDh9D6zX547N87wq3MpJKiXmUd4OIcueKyRZpYpIvmmcwUVEJMxa5R2zzBbYXROJ8xVd2geacXIHJQO23egwZiG5O_FxG8QFxrh4_uzHeW63_FwCur12TcaofBG7vh_MOJpCJTCfE0ZIz6x_lTAQoBeajff417eNC62yQLLJ8xrYeIS1nZv-h-u0Hp2iSUM4XfNjFo4Y1INWyt3kdTtIcwGrjs41fEs-F2dyw-mTmCVamKGVYLBhemH7_5q1CN8C8jPvvY7uWoDe2DEi8hUPxbtejCxzN5yTzgz-yF8D5DMORP-BsE-Wb9QC5KnDadUiOStszZvrBIHZlnaCLqXDRbIBJ-vEj8tR33HKFOpv4jt9oTwVPWabO4jR8UWcrEwXmA9vA-LqPlMTlVHrqQKKrCzPbZOHcFcB3QB8LRerGfJj8KezW4tR08QbvSHcOQGZ1XIaUo8m5g2jBksftOudpryoj9IHE59EA2bojiMVDDDDfDTqpc3eRZp25QGab_ihB2LWyU0V5Z3ZcSbkVLtzHoQBZS-qX9BOZYv5uJFHVgiVvGUiwjFpvff8ajMn_hObu7cdtX4dtqMhN8_Wfo8xu-fBVffVLu6nx70MUO00IzJbT2FBzDiO1v6TygrrCKK-qXhEvgobTLfmJeXTYIzNpf633we-CmJrhwDV6KyyjlIKsmWlA7q2S8j65v3UcUmYOJN9dvEN38NHSkR-9qdHvuCu5W2IprxoNxSQRaghY3DNorgIoEw-TqzQjayuA-OYz1JCDuuHcDgAPGYNRph9U6li17X2w5Kw8rmUGA6GUa3whaoDB5q8-W21bVoWc_PeOok09ER_5L69U6YSR2p2dITCBKNNfDRJa82lAR7Pd0xRwrmC4bKkb9bXNIi32vMVtgFKBEABl8AsuvCqHjLTY3hLKSuchBqTJdULHD9j-Y76kSS4NVJyvj4pHVFFdMTs4NIBcjUozd06EZNlKvFZDwLNpHQT-OhBYjvtXTf7BEpEeYTLOhQnfhnt4UEDNT3TZI5Xmxptf1s7_qnfYF-XlX96gxM7zvpCSAfSibPdQ8l-gCjsnsxEAngF2_PSP67dd7QtZUE9ooo6NduNv5DoLe0dQnQMG0JIAfE41ZuvoF3hwMrBlp-Ddzq0DUQ2-kLNRpaAbF-8EJr3Xc8Atv9AoSxLFbounjxkbDJVCsJra-8qoCoRwOEpf4ej7sJvNxBNWfghPP7__9srC_qRxxOrJXl3Fe2NZW46uGr6QhOMjVqgjhSrdUko9D30O7Ca6RglEzQppxy7GPR6wXtUt8LYG7O43C8khK0lnM=" target="_blank" rel="noopener">Instagram</a>,&nbsp;<a style={{
							color: '#c36',
							textDecoration: 'none'
						}} href="https://www.globenewswire.com/Tracker?data=wJwOFzRaZ5CBrU-9bObtPkxNGdXdcHn1lGk3mRQi6wRgv2wG3vFSnhspWoYnjdEeGkWlgbUelOcnpUys_DdpeZ-9bKt_XRt3W-rY4LYbc49KOiGQHVtP8L8PTQzFHv8qrWbcCP7H4luJ-qb05E8MEvawsXadpdtBAgnEvy5uZaPliZFllknuvxIoebsOKzhFsaPNo9uaz-VeuHonnIzE6q5ezHJr1FRcJUanaZmAgBMOHLwQH17f5AeYE2DofNfr4ur_CiEomDUuua0jcsEskrrIYNzt7xt0bWirnFoUCHE=" target="_blank" rel="noopener">Apple Podcasts</a>&nbsp;and&nbsp;<a style={{
							color: '#c36',
							textDecoration: 'none'
						}} href="https://www.globenewswire.com/Tracker?data=mtHTBqDf-PAH5e-YWS29SBkhw0agn7tBE-4zjEbhYYxsugAo8n9jN-Z20Uc5DQRp5ZeVAa6XG9sH7CGCdUlBT6eTZ595aNvPvQ4LEo6JJtZ8hO-C1LbmOv5UdupfPASSJFcNi5s6LBFgCgtxW6HmHoXSewRi70EtXYJnJCWHbPCSCgVpYsyiTs83u1P6Nt2JjBTI9kynEAitLCAPLGYUrR-1T4ArV0ri6Nzu1RM-4Qx47r73KWpHSNBI_pCYdokI" target="_blank" rel="noopener">Spotify</a>.
						</p>


						<h3 style={{
						fontWeight: 600,
    				fontSize: 36
					}}>
							About FFF Enterprises, Inc.
						</h3>
						<p 
						>Founded in 1988, FFF Enterprises Inc. is a privately held, multibillion-dollar specialty pharmaceutical distributor and diversified healthcare company. FFF Enterprises is the parent company to leading&nbsp;<a href="https://www.nufactor.com/" style={{
							color: '#c36',
							textDecoration: 'none'
						}}  target="_blank" rel="noopener">specialty infusion pharmacy Nufactor, Inc.</a>, as well as&nbsp;<a style={{
							color: '#c36',
							textDecoration: 'none'
						}}  href="https://www.incirclereview.com/" target="_blank" rel="noopener">InCircle, LLC</a>&nbsp;and&nbsp;<a 
						style={{
							color: '#c36',
							textDecoration: 'none'
						}}
						href="https://www.rightnowinventory.com/" target="_blank" rel="noopener">RightNow Inventory™</a>. 

						Our partners include global pharmaceutical and biologics manufacturers, prestigious healthcare systems, large and independent retail pharmacies, and leading alternate care sites. Our nationwide commerce is supported by a network of distribution and infusion pharmacy locations utilizing world-class technology and cybersecurity solutions. Please visit&nbsp;

						<a style={{
							color: '#c36',
							textDecoration: 'none'
						}}  href="https://www.fffenterprises.com/" target="_blank" rel="noopener">www.FFFEnterprises.com</a>, as well as&nbsp;

						<a style={{
							color: '#c36',
							textDecoration: 'none'
						}}
						href="https://www.linkedin.com/company/fff-enterprises/" target="_blank" rel="noopener">LinkedIn</a>,&nbsp;

						<a 
							style={{
							color: '#c36',
							textDecoration: 'none'
						}}
						href="https://www.instagram.com/fffenterprises/" target="_blank" rel="noopener">Instagram</a>,&nbsp;

						<a style={{
							color: '#c36',
							textDecoration: 'none'
						}}  href="https://www.facebook.com/fffenterprises/" target="_blank" rel="noopener">Facebook</a>&nbsp;and&nbsp;

						<a style={{
							color: '#c36',
							textDecoration: 'none'
						}}  href="https://www.youtube.com/channel/UChXybTn6ljR7qIRlE3PW-dg" target="_blank" rel="noopener">YouTube</a>&nbsp;for more information about the company.</p>
					</div>
				

				<div>
					<h3 style={{
						fontWeight: 600,
    				fontSize: 36,
    				marginLeft: 222,
					}}
					>
						Contact Us
					</h3>
					<div style={{
						display: 'flex',
						flexDirection: 'row',
						textAlign: 'left',
					marginLeft: 222,
					marginRight: 222,
							fontSize: 20,
							
							color: '#2D2D2D',
							fontWeight: 400
					}}>
							<p style={{
								marginRight: 300
							}}>
								<strong>Emergent BioSolutions</strong><br/>400 Professional Drive, Suite 400<br/>Gaithersburg, MD 20879
							</p>
							<p>
								<strong>FFF Enterprises, Inc.</strong><br/>44000 Winchester Road<br/>Temecula, CA 92590
							</p>
					</div>
				</div>


		
				
			
		</div>
	)
}